import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-root-loader',
    templateUrl: './root-loader.component.html',
    styleUrls: ['./root-loader.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RootLoaderComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}
